// extracted by mini-css-extract-plugin
export default {"logout-btn":"LogoutComponent_logout-btn__7OqXq","tooltip-text":"LogoutComponent_tooltip-text__S11GM"};